import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AdminServices from '../../services/AdminServices';
import Pagetitle from '../../component/PageTitle';

function AddAdmin() {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState({
    name: '',
    role: '',
    email: '',
    mobileNo: '',
    password: '',
    confirmPassword: '',
    status: '',
  });

  const [errors, setErrors] = useState({
    passwordMismatch: false,
  });

  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });

    // Reset errors when fields are changed
    if (name === 'password' || name === 'confirmPassword') {
      setErrors({ ...errors, passwordMismatch: false });
    }
  };

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Validate password and confirmPassword
    if (formValues.password !== formValues.confirmPassword) {
      setErrors({ ...errors, passwordMismatch: true });
      return;
    }

    try {
      await AdminServices.createAdmin(formValues);
      alert('Admin user created successfully');
      navigate('/admin-user');
    } catch (error) {
      console.error('Failed to create admin user', error);
    }
  };

  return (
    <div className="right_col" role="main">
      <Pagetitle></Pagetitle>
      <div className="container-box">
        <div className="container-box-top-header justify-content-end">
          <div className="sub-title-box-right">
            <Link className="site-btn-green" to="/admin-user">
              Admin User List
            </Link>
          </div>
        </div>
        <div className="container-box-inner px-4">
          <div className="row">
            <div className="col-md-12">
              <div className="page-details">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Role*</label>
                        <select
                          className="form-control"
                          value={formValues.role}
                          onChange={handleInputChange}
                          name="role"
                          required
                        >
                          <option value="">--Select role--</option>
                          <option value="Admin">Admin</option>
                          <option value="Investor">Investor</option>
                          <option value="User">User</option>
                          <option value="Helper">Helper</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Name*</label>
                        <input
                          type="text"
                          name="name"
                          value={formValues.name}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Enter full name"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Email Address*</label>
                        <input
                          type="email"
                          name="email"
                          value={formValues.email}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Enter email address"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Phone Number*</label>
                        <input
                          type="text"
                          name="mobileNo"
                          value={formValues.mobileNo}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Enter phone number"
                          required
                          maxLength={10}
                        />
                      </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Password*</label>
                        <input
                          type="password"
                          name="password"
                          value={formValues.password}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Enter password"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Confirm Password*</label>
                        <input
                          type="password"
                          name="confirmPassword"
                          value={formValues.confirmPassword}
                          onChange={handleInputChange}
                          className="form-control"
                          placeholder="Re-enter password"
                          required
                        />
                        {errors.passwordMismatch && (
                          <span style={{ color: 'red', fontSize: '12px' }}>
                            Passwords do not match.
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                      <div className="input-field">
                        <label>Status</label>
                        <select
                          className="form-select form-control"
                          value={formValues.status}
                          onChange={handleInputChange}
                          name="status"
                        >
                          <option value="">--Select Status--</option>
                          <option value="Active">Active</option>
                          <option value="Inactive">Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <button type="submit" className="site-btn-green">
                    Save
                  </button>
                  <button
                    type="button"
                    className="site-btn-green ms-3"
                    style={{ backgroundColor: '#D5D6DD', color: '#232859' }}
                    onClick={() => navigate('/admin-user')}
                  >
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddAdmin;
